<template>
  <v-container :key="$route.fullPath">
  <v-progress-circular indeterminate v-if="loading" id="calendarSpinner"/>
    <v-sheet class="pa-4 calendar-container">
      <full-calendar
        ref="fullCalendar"
        :options="calendarOptions"
        min-height="600"
      />
    </v-sheet>
  </v-container>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
  #calendarSpinner {
    z-index: 99999;
    top: -10px;
    left: 50%;
    position: absolute;
  }
.fc-icon {
  vertical-align: baseline !important;
  font-size: 1em !important;
}
.fc-event {
  background-color: $icon-blue;
  .fc-event-title {
    text-overflow: ellipsis
  }
}
.fc .fc-button-primary {
  background-color: $icon-blue;
  border-color: $icon-blue;
  color: #fff;
  border-radius: 2px;
  &:hover {
    background-color: lighten($icon-blue, 3%);
    border-color: lighten($icon-blue, 3%);
  }
}

/* sad hack because the library doesn't seem to respect the navLinks value */
.fc-daygrid-day-number,
.fc-col-header-cell-cushion {
  color: #000 !important;
  text-decoration: none !important;
  cursor: default !important;
  &:hover {
    text-decoration: none !important;
  }
}

@media (max-width: 539px) {
  .v-sheet {
    padding: 0 !important;
  }
  .fc {
    .fc-toolbar {
      display: block;
      width: 100%;
      .fc-toolbar-chunk {
         display: block;
        .fc-toolbar-title {
           padding-bottom: 10px;
        }
      }
    }
  }
}
</style>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import DSECMixin from "./DSECMixin";
import permissionsMixin from "@/mixins/permissionsMixin.js";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import 'fix-date'; // Let's use fix date since dates and Safari don't mix.

export default {
  mixins: [DSECMixin, permissionsMixin],
  components: {
    "full-calendar": FullCalendar
  },
  data() {
    return {
      events: [],
      showContainer: true,
      loading: true,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        eventDataTransform: this.transform,
        events: this.load,
        eventClick: this.viewEvent,
        navLinks: false,
        headerToolbar: {
          start: "title", // will normally be on the left. if RTL, will be on the right
          center: "",
          end: "today prev,next" // will normally be on the right. if RTL, will be on the left
        }
      }
    };
  },

  methods: {
    async load(fetchInfo, successCB, failCB) {
      let eventData;
      this.showContainer = false;
      try {
        this.loading = true;
        eventData = await this.$http.get(
          `dsec/events?start=${fetchInfo.startStr}&end=${fetchInfo.endStr}`
        );
      } catch (err) {
        failCB(err);
      }

      this.events = eventData.body.data;
      this.loading = false;
      this.showContainer = true;
      successCB(
        // Updated 2020-12-2: The value of this.events is an object,
        // originally this code was calling .map on an object (this.events)
        // and that caused an error. I don't know if something has changed
        // in the api such that we now get an object instead of array,
        // but I have updated this code to work with the data we get now
        // since the calendar is broken otherwise.
        Object.values(this.events).filter(el => el && el.hasOwnProperty('name')).map(el => {
          // Workaround for this (https://github.com/fullcalendar/fullcalendar/issues/3679),
          // the suggested methodology (setting end time to 23:59:59) doesn't work.
          // So here I'm just adding a day to the events to appease the fullcalendar gods.
          var startDt = new Date(el.start_date);
          var endDt = new Date(el.end_date);
          endDt.setDate(endDt.getDate() + 1);

          return {
            // Format the date to YYYY-MM-DD.
            start: startDt.toISOString().split('T')[0],
            end: endDt.toISOString().split('T')[0],
            title: el.name,
            allDay: true,
            ...el
          };
        })
      );
    },
    viewEvent(arg) {
      this.$emit("view-event", "event-view", {
        id: arg.event.id,
        ...arg.event.extendedProps
      });
    },
    refresh() {
      // 2025-01-16: There is a bug where the calendar reference is not
      // available at the time this method is called. This is a workaround.
      if (this.$refs.hasOwnProperty('fullCalendar') && this.$refs.fullCalendar) {
        let calendarApi = this.$refs.fullCalendar.getApi();
        // 2025-01-16: There is a UX bug that prevents the calendar from
        // rendering consistently. With the current version of the calendar
        // library and Vue, the updateSize() function appears to refetch/refresh
        // the calendar more consistently and prevents the failed rendering issue.
        calendarApi.refetchEvents();
        calendarApi.updateSize();
      }
    },
    render() {
      // 2025-01-16: There is a bug where the calendar reference is not
      // available at the time this method is called. This is a workaround.
      if (this.$refs.hasOwnProperty('fullCalendar') && this.$refs.fullCalendar) {
        let calendarApi = this.$refs.fullCalendar.getApi();
        // calendarApi.updateSize();
        setTimeout(this.refresh, 100);
      }
    }
  },
  mounted() {
    EventBus.$on("refreshEvents", this.refresh);
    EventBus.$on("renderCalendar", this.render);
  }
};
</script>
